// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TMCItem_wrapper__WdLaf","avatar":"TMCItem_avatar__7Cncw","name":"TMCItem_name__nhwx6","role":"TMCItem_role__2gGI1","metadata":"TMCItem_metadata__CAfmd"};